module.exports = __webpack_public_path__ + "img/phone-notification-panel.4147f8ee.png";